import './UniWidgetColumnReportTwo.scss';
import { Form } from 'react-bootstrap';
import { useEffect, useState } from 'react';

export type UniWidgetColumnReportTwoProps = {
    options: UniWidgetColumnTwoOptions[],
    currentSelectedFilter: number,
    filterOptions: UniWidgetColumnTwoOptions[],
    onChangeFilter: (value: number) => void,
    columnReportWidth: number,
    columnReportHeight: number,
    maxValue?: number
};

export type UniWidgetColumnTwoOptions = {
    value: number,
    description: string,
    color?: string
}

const UniWidgetColumnReportTwo = (props: UniWidgetColumnReportTwoProps) => {
    const [currentFilterSelected, setCurrentFilterSelected] = useState(props.currentSelectedFilter);

    useEffect(() => {
        setCurrentFilterSelected(props.currentSelectedFilter)
    }, [props.currentSelectedFilter]);

    const setCurrentFilter = (value: number) => {
        setCurrentFilterSelected(value);
        props.onChangeFilter(value);
    }

    return (
        <>
            <div className='uni-widget-column-report-two'>
                {
                    <>
                        <div className='d-flex justify-content-between column-report-header'>
                            <div className='filter-select'>
                                <Form.Select
                                    onChange={(e) => {
                                        setCurrentFilter(parseInt(e.target.value));
                                    }}
                                    value={currentFilterSelected}
                                    >
                                    {
                                        props.filterOptions?.map((option, idx) => {
                                            return (
                                                <option key={idx} value={option.value}>{option.description}</option>
                                            )
                                        })
                                    }
                                </Form.Select>
                            </div>
                        </div>
                        <div className='d-flex justify-content-left items-graph-wrapper'>
                            <div className='items'>
                            {
                                props.options?.map((option, idx) => {
                                    return (
                                        <div key={idx} className='item-graph-wrapper' style={{ width: props.columnReportWidth + 'px', height: props.columnReportHeight + 'px'}}>
                                            <p className='value'>
                                                {option?.value > 0 ? option.value : ''}
                                            </p>
                                            <div
                                                className='item-graph'
                                                style={{
                                                    height: (option.value > 0 ? ((option?.value / (props.maxValue ?? 1)) * props.columnReportHeight) : props.columnReportHeight - 21) + 'px',
                                                    maxHeight: props.columnReportHeight + 'px',
                                                    backgroundColor: option?.color ? option.color : (idx & 1 ? '#02FF3E' : '#0F8A38')
                                                }}
                                                >
                                            </div>
                                        </div>
                                    )
                                })
                            }
                            </div>
                            <div className='columns'>
                            {
                                props.options?.map((option, idx) => {
                                    return (
                                        <p key={idx} className="description" style={{ width: props.columnReportWidth + 'px' }}> {option.description}</p>
                                    )
                                })
                            }
                            </div>
                        </div>
                    </>
                }
            </div>
        </>
    )
}

export default UniWidgetColumnReportTwo;